module.exports = __webpack_public_path__ + "school/img/guanyuwomen.0871a046.jpg";